import { ActionIcon, Box, Flex, Image, ThemeIcon } from '@mantine/core'
import classes from './PhotoControl.module.css'
import { IconPlus, IconX } from '@tabler/icons-react'
import ExampleUser from '@assets/exampleUser.png'

export interface PhotoControlProps {
  photo?: boolean
}

export const PhotoControl = (props: PhotoControlProps) => {
  const { photo } = props

  return photo ? (
    <div className={classes.PhotoControl__img}>
      <Image src={ExampleUser} />
      <div className={classes.PhotoControl__x}>
        <ActionIcon
          className={classes.PhotoControl__x}
          variant="filled"
          color="red"
        >
          <IconX size={18} />
        </ActionIcon>
      </div>
    </div>
  ) : (
    <Flex className={classes.PhotoControl} justify="center" align="center">
      <ThemeIcon variant="transparent" c="gray.4">
        <IconPlus size={22} />
      </ThemeIcon>
    </Flex>
  )
}
